import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../../../classes.js";
const Header = styled("header", {
  name: colorPickerName,
  slot: "ColorGroupHeader"
})(() => ({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  minHeight: 40
}));
export {
  Header
};
//# sourceMappingURL=Header.js.map
